import { CircularProgress, IconButton, IconButtonProps, Tooltip } from '@mui/material'

interface TableActionProps extends IconButtonProps {
    title: string
    showSpinner?: boolean
}

export default function TableAction({ title, showSpinner, children, ...rest }: TableActionProps) {
    return (
        <Tooltip title={title}>
            <IconButton
                key={title}
                {...rest}
                sx={{
                    ml: 1,
                    bgcolor: 'primary.main',
                    color: 'primary.contrastText',
                    '&:hover': { bgcolor: 'primary.light' },
                    '&$disabled': { bgcolor: 'action.disabledBackground' },
                }}
            >
                {showSpinner ? <CircularProgress size={24} /> : children}
            </IconButton>
        </Tooltip>
    )
}
